<template>
  <div>
    <div class="control">
      <div
        style="width: auto; height: 10px; border-bottom: 2px dashed #1e88ff"
      ></div>
      <div class="control2">
        <img src="../images/flow/编组43备份.png" /><span class="fontcss1">身份验证</span>
      </div>
      <div
        style="width: 20%; height: 10px; border-bottom: 2px dashed #1e88ff"
      ></div>
      <div class="control2" style="color: #1e88ff">
        <img src="../images/flow/编组6备份.png" /><span class="fontcss">风险测评</span>
      </div>
      <div style="width: 20%; height: 10px; border-bottom: 2px dashed #999999"></div>
      <div class="control2">
        <img src="../images/flow/编组6备份6.png" /><span class="fontcss2">电子签名</span>
      </div>
      <div style="width: auto; height: 10px; border-bottom: 2px dashed"></div>
    </div>
    <div>
      <div class="catalogue">
        <div class="catalogue3" @click="returnback">	&lt;返回</div>
        <div class="catalogue1" id="catalogue1" @click="contract">风险测评问卷</div>
      </div>
      <div class="content">
        <div class="control4" >
          <img src="../images/flow/编组flow12.png" />
        </div>
        <div class="fontcss3"><span class="font1">客户风险承受能力类型评估为</span></div>
        <div class="fontcss3"><span class="font">进取型</span></div>
      </div>
      <div class="content_1">
        <div class="control4" >
          <span class="font2">当前风险承受能力评测结果显示客户为进取型投资者，适合购买中高风险类产品。</span>
          <span class="font2">当前产品与客户的风险承受能力相匹配！</span>
        </div>
      </div>
      <div class="text1">
          点击下方按钮以确认风评结果
           <div class="bnt2" @click="recur">重新发起风险测评</div> 
           <div class="bnt1" @click="notarize" >确认风险测评结果并推送</div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "flow",
  mounted(){
			this.getFile();
    	},
  data() {
    return {
      judge: true,
      bank: "中国工商银行股份有限公司",
      name: "李晓伟",
      base64Img:'',
    };
  },
  methods:{
    getFile(){
          const parames = {
            data: {
              fileCode:"001", 
            },
          };
          this.$_post(this.$API.getFile, parames).then(res => {
              let string= res.data.demoFiles.file1;
              this.base64Img = 'data:image/png;base64,'+string;
          });
      },
      contract(){
         this.judge=true
         this.switchover()
      },
      prospectus (){
          this.judge=false
          this.switchover()
      },
      switchover (){
          let a = document.getElementById("catalogue1")    
          let b = document.getElementById("catalogue2")
          if(this.judge){
              b.style.fontWeight="500"
              a.style.fontWeight="bold"
          }else{
              a.style.fontWeight="500"
              b.style.fontWeight="bold"
          }
      },
      returnback(){
        this.$router.push({path:'/flow5'})
      },
      
      recur(){
        alert("重新测评");
      },
      notarize(){
        if(true){
            this.$router.push({path:'/flow7'})
        }
      }
  },


};
</script>

<style  scoped>
* {
  margin: 0;
}
.font{
  width: 54px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #eb1c1c;
  line-height: 25px;
  letter-spacing: 0px;
}
.font1{
  width: 182px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #333333;
  line-height: 20px;
  letter-spacing: 0px;
}
.font2{
  width: 260px;
  height: 108px;
  font-size: 12px;
  font-family: PingFang, PingFang-SC;
  font-weight: SC;
  text-align: left;
  color: #333333;
  line-height: 19px;
  letter-spacing: 0px;
}

.bnt {
  width: 300px;
  height: 5rem;
  font-size: 2rem;
  /* font-weight: bold; */
}
.bnt2{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #3F96FC;
    border-spacing: 1px;
    border-style: solid;
    border-color: #3F96FC;
    /* background: #3F96FC; */
    width: 14.7rem;
    height: 3rem;
    background: #ffffff;
    border: 1px solid #3f96fc;
    border-radius: 4px;
    margin-bottom: 10px;
}
.control {
  width: 300px;
  height: 5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.control2 {
  font-size: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.control4{
  font-size: 0.4rem;
  height: 150px;
  margin: 100 0 0 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content {
  width: 300px;
  height: 13rem;
  display: flex;
  /* justify-content: center; */
  overflow-y:auto;
  align-items: center;
  flex-direction: column;
}
.content_1 {
  width: 300px;
  height: 10rem;
  display: flex;
  /* justify-content: center; */
  overflow-y:auto;
  align-items: center;
  flex-direction: column;
}
.content1 {
  width: 88%;
  height: 10px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.catalogue{
   width: 300px;
   height: 36px;
   background:#F3F3F3;
   display: flex;
   flex-direction: row;
   color: #09254C;
}
.catalogue1{
    width: 50%;
    /* height: 3rem; */
    background:#F3F3F3;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 45px;
    font-size: 1rem;
}   
.catalogue3{
    width: 60px;
    height: 36px;
    background:#F3F3F3;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
}  
.text1{
   width: 300px;
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
   /* height: 10rem; */
   color: #333;
}

.bnt1{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #fff;
    background: #3F96FC;
    width: 15rem;
    height: 3rem;
}
.fontcss{
  width: 53px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #1e88ff;
  line-height: 18px;
}
.fontcss1{
  width: 60px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #333333;
  line-height: 18px;
}
.fontcss2{
  width: 60px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #999999;
  line-height: 18px;
}
.fontcss3{
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #999999;
  line-height: 18px;
}
</style>